import axios from 'axios';
import Loader from 'components/Loader';
import { useAuth } from 'contexts/AuthContext';
import { baseURL } from 'lib';
import React, { useEffect, useState } from 'react'

const AdminRoutes = ({ children }) => {
  const [ok, setOk] = useState(false);
  const { auth } = useAuth();

  useEffect(() => {
    const authCheck = async () => {
      const res = await axios.get(`${baseURL}/admin/user/admin-auth`);
      if (res.data.ok) {
        setOk(true);
      } else {
        setOk(false);
      }
    };

    if (auth?.token) authCheck();
  }, [auth?.token]);

  return ok ? children : <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
  }}>
    <Loader />
  </div>;
}

export default AdminRoutes